/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { EnableMaintenanceModeRequestDto } from './EnableMaintenanceModeRequestDto';
import {
    instanceOfEnableMaintenanceModeRequestDto,
    EnableMaintenanceModeRequestDtoFromJSON,
    EnableMaintenanceModeRequestDtoFromJSONTyped,
    EnableMaintenanceModeRequestDtoToJSON,
} from './EnableMaintenanceModeRequestDto';

/**
 * @type UpdateConnectionStringsRequestDtoMaintenanceModeRequestDto
 * 
 * @export
 */
export type UpdateConnectionStringsRequestDtoMaintenanceModeRequestDto = EnableMaintenanceModeRequestDto;


export function UpdateConnectionStringsRequestDtoMaintenanceModeRequestDtoFromJSON(json: any): UpdateConnectionStringsRequestDtoMaintenanceModeRequestDto {
    return UpdateConnectionStringsRequestDtoMaintenanceModeRequestDtoFromJSONTyped(json, false);
}

export function UpdateConnectionStringsRequestDtoMaintenanceModeRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateConnectionStringsRequestDtoMaintenanceModeRequestDto {
    if (json == null) {
        return json;
    }
    // This is the original code, had to remove spread operator for const object enums that are not spreadable
    // return { ...EnableMaintenanceModeRequestDtoFromJSONTyped(json, true) };
    return  EnableMaintenanceModeRequestDtoFromJSONTyped(json, true);
}

export function UpdateConnectionStringsRequestDtoMaintenanceModeRequestDtoToJSON(value?: UpdateConnectionStringsRequestDtoMaintenanceModeRequestDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }

    if (instanceOfEnableMaintenanceModeRequestDto(value)) {
        return EnableMaintenanceModeRequestDtoToJSON(value as EnableMaintenanceModeRequestDto);
    }

    return {};
}

/**
 * Check if a given object implements the UpdateConnectionStringsRequestDtoMaintenanceModeRequestDto interface.
 */
export function instanceOfUpdateConnectionStringsRequestDtoMaintenanceModeRequestDto(value: any): value is UpdateConnectionStringsRequestDtoMaintenanceModeRequestDto {
    if (instanceOfEnableMaintenanceModeRequestDto(value)) return true;
    return false;
}

